import { BqSelect, BqCheckbox, BqOption } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqSelect = styled(BqSelect)`
  &::part(label){
    gap: 0;
    justify-content: space-between;
  }
`

export const StyledBqCheckbox = styled(BqCheckbox)`
  pointer-events: none;
`

export const StyledBqOption = styled(BqOption)`
  &::part(label){
    display: flex;
    align-items: center;
  }
`
